<div class="meeting-prep-feedback">
  <div class="meeting-prep-feedback__row">
    <ninety-button
      flat
      icon
      class="meeting-prep-feedback__toggle"
      [disabled]="helpful() === null"
      (click)="toggleExpanded()"
      [ariaLabel]="expanded() ? 'Hide feedback comment' : 'Add a feedback comment'">
      <terra-icon [icon]="expanded() ? 'caret-down' : 'caret-up'" size="20" />
    </ninety-button>

    <span class="meeting-prep-feedback__label">Was this helpful?</span>

    <div class="meeting-prep-feedback__thumbs">
      <button
        type="button"
        class="meeting-prep-feedback__thumb"
        [class.meeting-prep-feedback__thumb--active]="helpful() === true"
        [attr.aria-pressed]="helpful() === true"
        (click)="rate(true)">
        <terra-icon icon="thumbs-up" size="20" />
        Yes
      </button>
      <button
        type="button"
        class="meeting-prep-feedback__thumb"
        [class.meeting-prep-feedback__thumb--active]="helpful() === false"
        [attr.aria-pressed]="helpful() === false"
        (click)="rate(false)">
        <terra-icon icon="thumbs-down" size="20" />
        No
      </button>
    </div>
  </div>

  @if (expanded()) {
    <textarea
      class="meeting-prep-feedback__textarea"
      rows="2"
      [placeholder]="placeholder()"
      [ngModel]="comment()"
      (ngModelChange)="onCommentChange($event)"></textarea>
    <ninety-button filled primary class="meeting-prep-feedback__submit" (click)="submit()">
      Submit Feedback
    </ninety-button>
  } @else if (thanked()) {
    <p class="meeting-prep-feedback__thanks">Thanks for your feedback!</p>
  }
</div>
